import React from 'react';
import DocSearch from "../../../view/cmn/docSearch/components/DocSearch";


const FormSearchCriteria = (props) => {
    const { formObject, action, enableSearch, enableGroups, enablefav} = props;

    const onCriteriaChange = (reload, criteriaValue) => {
        let customAction = {...action};
        customAction.actionParam["searchCriteria"] = criteriaValue;
        customAction.actionMessage = "Searching";
        formObject.onFormAction(customAction, null, null);
    }

    return (
        <DocSearch viewData={formObject} onSearchByCriteria={onCriteriaChange}
            enableSearch={enableSearch} enableGroups={enableGroups} enablefav={enablefav}
        />
    )
}

export default FormSearchCriteria
